export default __webpack_public_path__ + "static/media/01.deb07d01.jpg";